import { Component, OnInit, Output, EventEmitter, Input, inject } from '@angular/core';
import { DocumentService } from 'src/app/services/document.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';
import { getLocalTimeOffset } from 'src/app/shared/timezone.util';
import {
  EmailRecipientValidation,
  validateEmailRecipients
} from 'src/app/shared/email-domain.util';

@Component({
    selector: 'app-share-modal',
    templateUrl: './share-modal.component.html',
    styleUrls: ['./share-modal.component.css'],
    standalone: false
})
export class ShareModalComponent implements OnInit {
  private documentService = inject(DocumentService);
  private authService = inject(AuthService);


  loading = true;
  @Input() deId = false;
  file = '';
  data: any = {};
  // rawData holds the original unmasked payload to send to server
  rawData: any = {};
  @Output() completed = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<any>();
  type!: string;
  toEmail: any;
  fromEmail!: string;
  message="";
  sharableUrl: any = [];
  selectedAudit: any[] = [];
  pdfInfo: any = {};
  showLink = false;
  files: any = [];
  body:any;
  subject = "Diversion Surveillance Files For Review"
  url: any;
  cannedText = "File(s) attached for your review. Please handle confidentially and do not forward. If others need access, please request through the diversion team. If you feel this email was received in error, notify sender and delete this message.";
  shareType = '';
  shareLanIds: string[] = [];
  recipientEmailTouched = false;
  recipientEmailValidationForced = false;
  recipientEmailValidation: EmailRecipientValidation = validateEmailRecipients('');


  ngOnInit(): void {
    this.url = environment.apiUrl;
  }

  setSharableData(data: any, sharableType: any, deid=false, additionalLanIds: string[] = []){
    this.loading = true;
    this.message = ""
    this.toEmail = ""
    this.fromEmail = ""
    this.resetRecipientEmailValidation()
    this.sharableUrl = []
    // keep a raw copy for payload and a separate display copy that can be masked
    this.rawData = JSON.parse(JSON.stringify(data));
    this.data = JSON.parse(JSON.stringify(data));
    this.shareType = 'Shared Variance Record(s)';
    const parentIds = data.map((item: any) => item.adminId || item.lanId).filter(Boolean);
    this.shareLanIds = Array.from(new Set([...parentIds, ...additionalLanIds])) as string[];
    this.type = sharableType
    if (this.type == 'activities'){
      this.subject = this.deId ? 
        "Variance Report Generated by Software - Shared By - " + this.authService.user.fullname :
        "Variance Report for " + data[0]['adminId'] + " Generated by Software - Shared By - " + this.authService.user.fullname
    }
    if(this.type == "activities"){
      this.getActivityLink(deid)
      }
    if (this.deId){
      // mask only the display copy
      this.data[0]['employeeName'] = "******, ******"
      this.data[0]['adminId'] = "********"
    }
    this.body = "User Name: " + this.data[0]["employeeName"] + "\r\n" + 
                "Role: "+ this.data[0]["adminGroup"] + "\r\n" + 
                "User ID: " + this.data[0]["adminId"] + "\r\n" + 
                "Stock Area: "  + this.data[0]["loc"] + "\r\n" + 
                "FollowUp: " + this.data[0]["followUp"];
  }

  setShareableFollowUp(data: any, sharableType: any){
    this.loading = true;
    this.message = ""
    this.toEmail = ""
    this.fromEmail = ""
    this.resetRecipientEmailValidation()
    // preserve raw data for payload, mask only display copy
    this.rawData = JSON.parse(JSON.stringify(data));
    this.data = JSON.parse(JSON.stringify(data));
    this.shareType = 'Shared User History';
    this.shareLanIds = [data['lanId']];
    if (this.deId){
      this.data['lanId'] = "********"
      this.data["employeeName"] = "******, ******"
    }
    this.type = sharableType
    this.subject = this.deId ?
      "Variance Report Generated by Software - Shared By - " + this.authService.user.fullname :
      "Variance Report for " + data['lanId'] + " Generated by Software - Shared By - " + this.authService.user.fullname
    this.getFollowUpLink()
    this.body = "User Name: " + this.data["employeeName"] + "\r\n" + 
                "Role: "+ this.data["adminGroup"] + "\r\n" + 
                "User ID: " + this.data["lanId"] + "\r\n" + 
                "Area: "  + this.data["locationGrouping"] + "\r\n" + 
                "FollowUp: " + this.data["followUp"];
  }
  
  setSharableISData(data: any, sharableType: any){
    this.loading = true;
    this.message = ""
    this.toEmail = ""
    this.fromEmail = ""
    this.resetRecipientEmailValidation()
    this.rawData = JSON.parse(JSON.stringify(data));
    this.data = JSON.parse(JSON.stringify(data));
    this.shareType = 'Shared Investigative Summary Report';
    this.shareLanIds = [data['lanId']];
    if (this.deId){
      this.data['lanId'] = "********"
      this.data["employeeName"] = "******, ******"
    }
    this.type = sharableType
    this.subject = this.deId ?
      "Investigative Summary Report - Shared By - " + this.authService.user.fullname :
      "Investigative Summary Report " + data['lanId'] + " - Shared By - " + this.authService.user.fullname
    this.getISRLink()
    this.body = "User Name: " + this.data["employeeName"] + "\r\n" + 
                "Role: "+ this.data["adminGroup"] + "\r\n" + 
                "User ID: " + this.data["lanId"] + "\r\n" + 
                "Area: "  + this.data["locationGrouping"] + "\r\n" + 
                "FollowUp: " + this.data["followUp"];
  }

  async getISRLink(){
    const payload = {};
    // send the original unmasked data and include any deIdentify flag present on it;
    (payload as any)["investigativeSummary"] = this.rawData || this.data;
    (payload as any)["type"] = this.type;
    (payload as any)['lanId'] = this.data["lanId"];
    (payload as any)['timeOffset'] = getLocalTimeOffset();

    this.documentService.requestISRToken(payload).subscribe(
      (res)=> {
        const message= {
          life:5000,
           severity: 'success', 
           summary: 'PDF Created',
           detail: '',
           files:res
          };
      this.files = message.files
      this.loading=false;
      // this.file = this.files?.split('/')[1]
        }
    );
  }

  async getFollowUpLink(){
    const payload = {};
    (payload as any)["adminfollowup"] = this.rawData || this.data;
    (payload as any)["type"] = this.type;
    (payload as any)['lan'] = this.data["lanId"];
    (payload as any)['timeOffset'] = getLocalTimeOffset();

    this.documentService.requestFollowUpToken(payload).subscribe(
      (res)=> {

        const message= {
          life:5000,
           severity: 'success', 
           summary: 'PDF Created',
           detail: '',
           files:res
          };
      this.files = message.files
      this.loading=false;
      this.file = this.files?.split('/')[1]
        }
    );
  }

  async getActivityLink(deid=false){
    const payload = {};
    // use original unmasked data for payload; rawData will contain deIdentifyData flag;
    (payload as any)["activities"] = this.rawData || this.data;
    (payload as any)["type"] = this.type;
    (payload as any)['lan'] = this.data[0]["adminId"];
    (payload as any)['deIdentifyData'] = deid;
    (payload as any)['timeOffset'] = getLocalTimeOffset();

    this.documentService.requestLinkToken(payload).subscribe(
      (res)=> {
        const message= {
          life:5000,
           severity: 'success', 
           summary: 'PDF Created',
           detail: '',
           files:res
          };
      this.files = message.files
      this.loading=false;
      this.file = this.files[0]?.split('/')[1]
        }
    );
    //.toPromise();
    // this.sharableUrl.push(this.documentService.getApiUrl()+"waste-module/share/"+response["token"])
    // this.documentService.generatePDF(this.pdfInfo)
  }
    // var response = await this.documentService.requestLinkToken(payload).toPromise();
    // var filterString = this.generateQueryStringFromObject(response);
    // this.sharableUrl = this.documentService.getApiUrl()+"a/share?"+filterString + "&deIdentify=" + payload["activities"]['deIdentifyData']

  get recipientEmailError(): string {
    if (!this.recipientEmailTouched || this.recipientEmailValidation.isValid) {
      return '';
    }

    if (!this.recipientEmailValidationForced && !this.recipientEmailValidation.isReadyForFeedback) {
      return '';
    }

    return this.recipientEmailValidation.message;
  }

  get canSendEmail(): boolean {
    return this.recipientEmailValidation.isValid;
  }

  onRecipientEmailsChange() {
    this.recipientEmailTouched = true;
    this.recipientEmailValidationForced = false;
    this.recipientEmailValidation = validateEmailRecipients(this.toEmail);
  }

  markRecipientEmailsTouched(forceValidationMessage = false) {
    this.recipientEmailTouched = true;
    this.recipientEmailValidationForced = this.recipientEmailValidationForced || forceValidationMessage;
    this.recipientEmailValidation = validateEmailRecipients(this.toEmail);
  }

  blockInvalidEmailSubmit(event: Event) {
    this.markRecipientEmailsTouched(true);

    if (!this.canSendEmail) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  private resetRecipientEmailValidation() {
    this.recipientEmailTouched = false;
    this.recipientEmailValidationForced = false;
    this.recipientEmailValidation = validateEmailRecipients(this.toEmail);
  }

  sendEmail(event?: Event){
    if (event) {
      this.blockInvalidEmailSubmit(event);
    }

    if (!this.canSendEmail) {
      return;
    }

    if(this.type == "activities")
    {
      this.sendActivityEmail()
    }
    else if (this.type == "adminfollowup"){
      this.sendAdminFollowUpEmail()
    }
  }

  private getApprovedRecipients(): string[] | null {
    this.markRecipientEmailsTouched(true);

    if (!this.recipientEmailValidation.isValid) {
      return null;
    }

    return this.recipientEmailValidation.recipients;
  }

  async sendAdminFollowUpEmail(){
    const recipients = this.getApprovedRecipients();
    if(!recipients)
    {
      return
    }
    if (this.deId){
      this.authService.user.fullname = "******, ******"
    }

    const body = this.message
    this.data.loc = this.data.locationGrouping

    await lastValueFrom(this.documentService.sendMail(recipients,this.subject,body,this.sharableUrl,this.files,this.data, this.cannedText, this.shareType, this.shareLanIds));
    const message= {
      life:5000,
       severity: 'success', 
       summary: 'Mail sent Successfully',
       detail: '',
      };
    this.completed.emit(message);
    this.closeModal.emit("yes")
  }

  async sendActivityEmail(){
    const recipients = this.getApprovedRecipients();
    if(!recipients)
    {
      return
    }
    const body = this.message
    this.data = this.data[0];

    await lastValueFrom(this.documentService.sendMail(recipients,this.subject,body,this.sharableUrl,this.files,this.data, this.cannedText, this.shareType, this.shareLanIds));
    const message= {
      life:5000,
       severity: 'success', 
       summary: 'Mail sent Successfully',
       detail: '',
      };
    this.completed.emit(message);
    this.closeModal.emit("yes")
  }

  tryClearWhitespaceFromGlobalSearch(params: any) {
    if (params.globalSearch) {
      const textToTrim: string = params.globalSearch;
      params.globalSearch = textToTrim.trim();
    }
  }

  generateQueryStringFromObject(params: any) {
    this.tryClearWhitespaceFromGlobalSearch(params);
    return Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
  }

  cancel(){
    this.closeModal.emit("yes")
  }

  parseFileName(text: any){
    const lst = text.split('/')
    return lst[lst.length-1]
  }

}
